import * as React from 'react';
import styled from 'styled-components';
import {WP_CONTENT_PREFIX, OPTION_PAGE} from '../constants';
import I18n from '../utils/i18n';
import {analyticsEvent} from "../utils/analytics";

const Relative = styled.div`
    position: relative;
    overflow-y: hidden;
    overflow-x: hidden;
`;

const Info = styled.div`
    position: absolute;
    height: 35vh;
    width: 70.6vw;
    top: 5vh;
    left: 14.8vw;
    background: #000000;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const Ground = styled.div`
    height: 5vh;
    width: 100vw;
    img {
      width: 100%;
      height: 100%;
    }
`;

export const InfoTitle = styled.div`
    font-size: ${props => props.fontSize ? props.fontSize : '3vh'};
    color: #ffffff;
    font-family: 'Pixel Coleco';
    margin-top: ${props => props.marginTop};
    max-width: 75%;
    text-align: center;
`;

export const GestureGif = styled.img`
    height: 14vh;
    margin-top: 2vh;
`;

const Settings = styled.div`
    position: absolute;
    bottom: 1vh;
    right: 1vw;
    display: flex;
    align-items: center;
`;

const SettingsText = styled.div`
    font-family: 'Pixel Coleco';
    font-size: 18px;
    color: #c0cbdc;
    margin-right: 0.5vw;
`;

const SettingsImg = styled.img`
    width: 2vw;
`;


export class GroundInfo extends React.Component {

    constructor() {
        super();
        this.onSettingsClick = this.onSettingsClick.bind(this);
    }

    onSettingsClick() {
        const {screen} = this.props;
        analyticsEvent('Onboarding',
            `Screen ${screen}`,
            'Settings'
        );
    }

    render() {
        const {children, extensionInstalled} = this.props;
        return (
            <Relative>
                <Info>
                    {children}
                    {
                        extensionInstalled ?
                            <a href={OPTION_PAGE} target="_blank" onClick={this.onSettingsClick}>
                            <Settings>
                                <SettingsText>{I18n.translate('settingsIcon')}</SettingsText>
                                <SettingsImg src={`${WP_CONTENT_PREFIX}/images/settings.svg`}/>
                                </Settings>
                            </a>:
                            null
                    }
                </Info>
                {Array(9).fill(0).map((e,i)=><Ground key={i}><img src={`${WP_CONTENT_PREFIX}/images/ground.png`}/></Ground>)}
            </Relative>

        );
    }
}
